import { useEffect } from 'react';
import { api } from '../../lib/api';
import { useAsync } from '../../hooks/useApi';
import { TemplateCard } from './TemplateCard';
import { LoadingSpinner } from '../Common/LoadingSpinner';

export function TemplateGallery() {
  const list = useAsync(api.listTemplates);

  useEffect(() => { list.run(); }, []);

  if (list.loading) return <LoadingSpinner label="Loading templates…" />;
  if (list.error)   return <div className="text-danger text-sm">{list.error}</div>;
  if (!list.data)   return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {list.data.templates.map(t => (
        <TemplateCard key={t.key} template={t} />
      ))}
    </div>
  );
}
